export default "__VITE_ASSET__DcrWmlSx__"